<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ForgotPassword" });
import { Form } from "../../../../components/index.js";
import { Heading, Paragraph } from "../../../../typography/index.js";
import { InputEmail } from "../../../user/index.js";
import Button from "../../../../elements/button/Button.svelte";
import { t } from "svelte-i18n";
import { AUTHENTICATION } from "../../services/store.js";
import * as API from "../../services/api.js";
let showSuccess = false;
let error = "";
const onSubmit = async () => {
    const RESPONSE = await API.sendPasswordUpdateUrl($AUTHENTICATION);
    if ("error" in RESPONSE) {
        ({ error } = RESPONSE);
        return;
    }
    showSuccess = true;
};
</script>

{#if showSuccess}

    <Paragraph
        label = 'component.session.forgot_password.success_message'
        css = '!mb-0'
        color = 'success'
    />

{:else}

    <Form { onSubmit } { error } id = 'forgot-password'>

        <Heading size = 'sm'>{ $t('component.session.forgot_password.heading') }</Heading>
        <Paragraph label = 'component.session.forgot_password.intro' />

        {#if Boolean(error)}
            <Paragraph label = { error } css = 'mt-4' color = 'error' />
        {/if}

        <InputEmail bind:value = { $AUTHENTICATION.email } />
        <Button
            type='submit'
            size = 'sm'
            label = 'component.session.forgot_password.submit_button'
            css = 'w-full'
        />

    </Form>

{/if}